import { Disease, RequestResult } from "domain/entities/disease";
import { DiseaseRepository } from "domain/repositories";

export default class CreateUseCase {
    private diseaseRepository: DiseaseRepository;
    
    public constructor(diseaseRepository: DiseaseRepository) {
        this.diseaseRepository = diseaseRepository
    }

    public async createDisease(disease: Disease, token: Promise<[string | null, string | null]>): Promise<[RequestResult, null] | [null, Error]> {
        const [t, ] = await token;
        if (t !== null) {
            return this.diseaseRepository.createDisease(disease, t);
        } else {
            return [null, new Error("Autenticación faltante")];
        }
    }
}